import * as actions from "./actionsTypes";

const initialData = {
  surveyLoading: false,
  saveLoader: false,
  surveyTemplate: null,
  surveyTemplateFail: null,
  formError: null,

  // Para Modal import cuestionario
  surveyImportLoading: false,
  saveLoaderImport: false,
  surveyTemplateImport: null,
  surveyTemplateImportFail: null,
  formImportError: null,

  // Para preguntas plantilla cuestionario
  questionLoading: false,
  saveLoaderQuestion: false,
  question: null,
  questionFail: null,

  // Para agregar preguntas
  questionSaveLoader: false,
  surveyTemplateQuestionFail: null,
};

export default function plantillaCuestionarioReducer(
  state = initialData,
  action
) {
  switch (action.type) {
    case actions.LOADING_PLANTILLA_CUESTIONARIO:
      return { ...state, surveyLoading: action.payload };
    case actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO:
      return { ...state, saveLoader: action.payload };
    case actions.GET_PLANTILLA_CUESTIONARIO:
      return { ...state, surveyTemplate: action.payload };
    case actions.PLANTILLA_CUESTIONARIO_FAIL:
      return { ...state, surveyTemplateFail: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    // Para Modal import cuestionario
    case actions.GET_PLANTILLA_CUESTIONARIO_IMPORT:
      return { ...state, surveyTemplateImport: action.payload };
    case actions.LOADING_PLANTILLA_CUESTIONARIO_IMPORT:
      return { ...state, surveyImportLoading: action.payload };
    case actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_IMPORT:
      return { ...state, saveLoaderImport: action.payload };
    case actions.PLANTILLA_CUESTIONARIO_IMPORT_FAIL:
      return { ...state, surveyTemplateImportFail: action.payload };
    case actions.FORM_IMPORT_FAIL:
      return { ...state, formImportError: action.payload };
    case actions.GET_SAVE_PLANTILLA_CUESTIONARIO_IMPORT:
      return {
        ...state,
        surveyTemplateImport: action.payload.surveyTemplateImport,
        surveyTemplate: action.payload.surveyTemplate,
      };

    // Para preguntas plantilla cuestionario
    case actions.GET_PLANTILLA_CUESTIONARIO_PREGUNTAS:
      return { ...state, question: action.payload };
    case actions.LOADING_PLANTILLA_CUESTIONARIO_PREGUNTAS:
      return { ...state, questionLoading: action.payload };
    case actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_PREGUNTAS:
      return { ...state, saveLoaderQuestion: action.payload };
    case actions.PLANTILLA_CUESTIONARIO_PREGUNTAS_FAIL:
      return { ...state, questionFail: action.payload };

    // Para agregar preguntas
    case actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_PREGUNTA:
      return { ...state, questionSaveLoader: action.payload };
    case actions.PLANTILLA_CUESTIONARIO_PREGUNTA_FAIL:
      return { ...state, surveyTemplateQuestionFail: action.payload };
    default:
      return { ...state };
  }
}
